'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:MyProfileCtrl
 * @description
 * # MyProfileCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
  .controller('AssignSurveyCtrl',
  ['$scope', '$routeParams', '$http', '$location', '$timeout', '$uibModal', 'Session', 'ApiUrl', 'authorized',
      function ($scope, $routeParams, $http, $location, $timeout, $uibModal, Session, ApiUrl, authorized) {
          var _surveyApi = ApiUrl.url('/Survey/');

          // If the user is not authorized for this grant, route them away
          if (!authorized) {
              $location.url('/');
              return;
          }
          var sessionObject = Session.getSessionObject();
          if (!sessionObject.isAuthenticated) {
              $location.url('/');
              return;
          }
          $scope.grantID = $routeParams.GrantID;
          $scope.surveyID = $routeParams.SurveyID;
          if (!$scope.grantID || !$scope.surveyID) {
              $location.url('/director');
              return;
          }

          var data = {
              GrantID: $scope.grantID,
              SurveyID: $scope.surveyID
          };

          var hadNobodyAssignedAtStart = true;
          $scope.peopleAvailableToAssignAtStart = 0;

          $scope.failedNotificationEmails = [];

          $http.get(_surveyApi + 'GetSurveyName/' + $scope.surveyID)
              .then(function (response) {
                  $scope.surveyName = response.data;
              });

          $http.post(_surveyApi + 'UsersForSurvey', data).then(function (response) {
              var peopleAssigned = 0;
              for (var i = 0; i < response.data.length; i++) {
                  var user = response.data[i];
                  user.IsChecked = user.AssignedToSurvey && !user.HasUnassignedPairs;

                  if (user.AssignedToSurvey && !user.HasUnassignedPairs) {
                      peopleAssigned++;
                  }
                  if (user.AssignedToSurvey) {
                      hadNobodyAssignedAtStart = false;
                  }
              }
              $scope.Users = response.data;
              $scope.peopleAvailableToAssignAtStart = $scope.Users.length - peopleAssigned;
          }, function () {
              $location.path('error');
          });


          $scope.assignAllCheckbox = false;

          $scope.selectAllUsers = function () {
              $scope.selectedIds = [];
              for (var i = 0; i < $scope.Users.length; i++) {
                  var user = $scope.Users[i];
                  if (!user.AssignedToSurvey || user.HasUnassignedPairs) {
                      user.IsChecked = $scope.assignAllCheckbox;
                  }
                  if (user.IsChecked && (!user.AssignedToSurvey || user.HasUnassignedPairs)) {
                      $scope.selectedIds.push(user.UserID);
                  }
              }
              $scope.updateAssignAllCheckbox();
          };

          $scope.selectedIds = [];

          $scope.selectUser = function (user) {
              if (user.IsChecked) {
                  //User added
                  $scope.selectedIds.push(user.UserID);
              }
              else {
                  //User removed
                  var index = $scope.selectedIds.indexOf(user.UserID);
                  if (index > -1) {
                      $scope.selectedIds.splice(index, 1);
                  }
              }
              $scope.updateAssignAllCheckbox();
          };

          $scope.updateAssignAllCheckbox = function () {
              var assignAllCheckbox = document.getElementById("AssignAll"); // there's no great way to set "indeterminate" for a checkbox with AngularJS, so just do it on the element itself
              // Show a "Check" in the assign all checkbox if all the people who can be selected are selected
              if ($scope.selectedIds.length === $scope.peopleAvailableToAssignAtStart) {
                  $scope.assignAllCheckbox = true;
                  assignAllCheckbox.indeterminate = false;
              }
              // Show a "Dash" in the assign all checkbox if some of the people who can be selected are selected
              else if ($scope.selectedIds.length > 0) {
                  $scope.assignAllCheckbox = false;
                  assignAllCheckbox.indeterminate = true;
              }
              // Show nothing in the assign all checkbox if none of the people who can be selected are selected
              else {
                  $scope.assignAllCheckbox = false;
                  assignAllCheckbox.indeterminate = false;
              }
          };

          $scope.assignSurvey = function () {
              // Clear any previously failed email alert
              $scope.failedNotificationEmails = [];

              var assignUsers = function () {
                  if ($scope.selectedIds.length > 0) {
                      var data = {
                          GrantID: $scope.grantID,
                          SurveyID: $scope.surveyID,
                          UserIDs: $scope.selectedIds
                      };

                      $http.post(_surveyApi + 'AssignSurveyToUsers', data).then(function (response) {
                          if (response.data.SuccessfullyAssigned) {
                              //If we were able to a assign the users then update the assignment status of the newly assigned uses
                              for (var i = 0; i < $scope.Users.length; i++) {
                                  var user = $scope.Users[i];
                                  if (user.IsChecked && (!user.AssignedToSurvey || user.HasUnassignedPairs)) {
                                      user.AssignedToSurvey = true;
                                      user.HasUnassignedPairs = false; // we just assigned all pairs we know about
                                  }
                              }

                              $scope.selectedIds = [];

                              $scope.assigned = response.data.SuccessfullyAssigned;
                              $scope.failedNotificationEmails = response.data.FailedNotificationEmails;

                              $timeout(function () {
                                  // Dismisses success alert after timeout
                                  $scope.assigned = false;
                              }, 5000);
                          }
                      }, function () {
                          $location.path('error');
                      });
                  }
              };

              if (hadNobodyAssignedAtStart) {
                  var assignModel = $uibModal.open({
                      animation: true,
                      templateUrl: 'assignSurveyNotification.html',
                      controller: 'assignSurveyNotificationCtrl'
                  });
                  assignModel.result.then(function (accepted) {
                      assignUsers();
                  });
              }
              else {
                  assignUsers();
              }


          };
      }])
.controller('assignSurveyNotificationCtrl', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {

    $scope.accept = function () {
        $uibModalInstance.close(true);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}]);



